import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';
import { userActionTypes } from './util';

const actions = createActions({
  USER: {
    UPDATE: (user) => ({ user }),
    API: {
      UPDATE: userActionTypes((response) => ({
        ...response.user,
        avatarUrl: response.avatarUrl
      }))
    }
  }
})

export const apiAction = (authToken, formData) => commonApiActions.authenticated.postFormData(API_ENDPOINT, authToken, formData, actions.user.api.update)

export function* updateUser(action) {
  const authToken = yield select(authTokenSelector);
  const { user: { userDetails, avatar } } = action.payload;
  const userFormData = {
    data: userDetails,
    file: avatar
  }

  yield put(apiAction(authToken, userFormData));
}

const configuration = {
  name: 'update',
  action: actions,
  sagas: updateUser,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true,
      isUpdating: true
    }),
    success: (state, action) => ({
      ...state,
      currentUser: {
        roleAssignments: state.currentUser.roleAssignments,
        teamMemberRoles: state.currentUser.teamMemberRoles,
        ...action.payload.user
      },
      isFetching: false,
      isUpdating: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetching: false,
      isUpdating: false,
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/update.js